import React from "react";
import Accountmanagementtitle from "../accountmanagement/Accountmanagementtitle";
import Accountform from "../accountmanagement/Accountform";


function Accountmanagement() { 
  
  return (
     
          <div className="favbg">
            <div className="innerwrapper Favourites_search">
                <div className="search_fav customscroll">
                  <Accountmanagementtitle />
                  <Accountform />
                </div>
            </div>
          </div>
          
          

    );
}

export default Accountmanagement;
